import { Component, ViewChild } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { BasicTextInputComponent } from '../../form/base-components/base-text-input/basic-text-input.component';
import { SelectBasicComponent } from '../../form/base-components/select-basic/select-basic.component';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { Controller } from 'apps/coverpath-client/public/js/Controller';
import { BaseModalComponent } from '../base-modal.component';
import { PaymentInformation } from '../../../../classes/PaymentInformation';
import { Utils } from '../../../../../common/js/Utils';
import { GiactUtils } from '../../../../../common/js/GiactUtils';
import { ValidationService } from './../../../services/validation/validation.service';
import { ValidationErrorMessages } from '../../../classes/UnsupportedUseCases';
import { PaymentService } from '../../../../../common/widgets/payment-update-widget/js/common/service/payment.service';

@Component({
  moduleId: module.id,
  templateUrl: './payment-modal.component.html',
})
export class PaymentModalComponent extends BaseModalComponent {
  @ViewChild('bankName') bankNameInput: BasicTextInputComponent;
  @ViewChild('ABA') abaInput: BasicTextInputComponent;
  @ViewChild('Account') accountInput: BasicTextInputComponent;
  @ViewChild('accountType') accountTypeInput: SelectBasicComponent;
  amountDue: string;
  totalCoverage: string;
  productDescription: string;
  coverageLabel: string;
  controller: Controller;
  accountCenterController;
  submitDisabled: boolean = true;
  paymentInformation: PaymentInformation;
  paymentInfoError: string;
  isAccountRoutingInfoSame: boolean = false;
  data;

  constructor(
    private amorphicService: AmorphicService,
    modalService: ModalService,
    private accountCenterService: AccountCenterService,
    private paymentService: PaymentService
  ) {
    super(modalService);
    this.modalService = modalService;
    this.accountCenterService = accountCenterService;
    this.controller = this.amorphicService.controller as Controller;
    this.paymentInformation = this.controller.accountCenterController.paymentInformation;
    this.accountCenterController = this.controller.accountCenterController;
    this.paymentService = paymentService;
  }

  ngOnInit(): void {
    this.amountDue = Utils.formatIntCurrency(this.data.amountDue);
    this.totalCoverage = Utils.formatIntCurrency(this.data.totalCoverage);
    this.productDescription = this.data.productDescription;
    this.coverageLabel = this.data.coverageLabel;
    this.paymentInformation.paymentAccountType = '2';
    this.paymentService.resetGiactResponse();

    setTimeout(async () => {
      await this.updateValidation();
    });
  }

  async onSubmit() {
    if (await this.updateValidation()) {
      return;
    }
    await this.controller.accountCenterController.applyUpdatedPaymentInformationToPolicy(
      this.accountCenterService.primaryPolicy.policyNumber
    );
    this.data.onSubmit();
    this.modalService.deactivate();
  }

  async updateValidation() {
    if (this.bankNameInput.val && this.abaInput.val && this.accountInput.val && this.accountTypeInput.selectedItem) {
      this.bankNameInput.triggerBase();
      this.abaInput.triggerBase();
      this.accountInput.triggerBase();
      const paymentInfo = {
        paymentABA: this.abaInput.value,
        paymentAccount: this.accountInput.value,
      };
      this.isAccountRoutingInfoSame = ValidationService.isAccountRoutingInfoSame(paymentInfo);
      if (
        !this.bankNameInput.isError &&
        !this.abaInput.isError &&
        !this.accountInput.isError &&
        !this.accountTypeInput.isError &&
        !this.isAccountRoutingInfoSame
      ) {
        const paymentInfoCombo: string = `${this.accountInput.val}${this.abaInput.val}`;
        const oldPaymentInfoCombo: string = this.accountCenterController.lastWebDebitAttemptCombination;

        if (ValidationService.verifyIsNewPaymentCombination(paymentInfoCombo, oldPaymentInfoCombo)) {
          const giactReponse = await ValidationService.verifyWebDebit(paymentInfo);
          this.accountCenterController.isGiactWebDebitValid = giactReponse.status === 'pass';
          this.accountCenterController.giactWebDebitResponseCode = giactReponse.normalizedResponseCode;
          this.accountCenterController.lastWebDebitAttemptCombination = paymentInfoCombo;
          this.isInvalidPaymentInfo();
          if (this.accountCenterController.isGiactWebDebitValid) {
            this.submitDisabled = false;
            return false;
          }
        } else if (this.accountCenterController.isGiactWebDebitValid) {
          //If account type and bank name is changed
          this.submitDisabled = false;
          return false;
        }
      }
    }

    this.submitDisabled = true;
    return true;
  }

  isInvalidPaymentInfo() {
    this.paymentInfoError = this.getErrorMessage();
    return (
      this.isAccountRoutingInfoSame ||
      GiactUtils.isInvalidPayment(
        this.accountCenterController.isGiactWebDebitValid,
        this.accountCenterController.giactWebDebitResponseCode,
        this.controller.mmGiactWebDebitVerificationServiceEnabled
      )
    );
  }

  getErrorMessage() {
    return this.isAccountRoutingInfoSame
      ? ValidationErrorMessages.samePaymentInfoError
      : GiactUtils.getNormalizedGiactMessage(
          this.controller.mmGiactWebDebitVerificationServiceEnabled,
          this.accountCenterController.giactWebDebitResponseCode
        );
  }

  cancel() {
    this.modalService.deactivate();
  }

  confirm() {}
}
